// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import Vue from 'vue'
import Router from 'vue-router'

import ApiKeyEdit from '@/components/ApiKeyEdit'
import ApiKeys from '@/components/ApiKeys'
import DeviceEdit from '@/components/DeviceEdit'
import Devices from '@/components/Devices'
import Index from '@/components/Index'
import Login from 'vue-common/components/Login'
import LogView from '@/components/LogView'
import Organizations from '@/components/Organizations'
import OrganizationEdit from '@/components/OrganizationEdit'
import PasswordResetConfirm from 'vue-common/components/PasswordResetConfirm'
import PasswordResetForm from 'vue-common/components/PasswordResetForm'
import PasswordResetRequest from 'vue-common/components/PasswordResetRequest'
import QRCode from '@/components/QRCode'
import Users from '@/components/Users'
import UserEdit from '@/components/UserEdit'
import UserMe from '@/components/UserMe'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          component: Devices,
          name: 'home'
        },
        {
          path: 'apikeys',
          component: ApiKeys,
          name: 'apikeys'
        },
        {
          path: 'apikeys/:id',
          component: ApiKeyEdit,
          name: 'apikeyEdit'
        },
        {
          path: '/devices',
          component: Devices,
          name: 'devices'
        },
        {
          path: '/devices/:id',
          component: DeviceEdit,
          name: 'deviceEdit'
        },
        {
          path: '/logs/:id',
          component: LogView,
          name: 'logView'
        },
        {
          path: 'organizations',
          component: Organizations,
          name: 'organizations'
        },
        {
          path: 'organizations/:id',
          component: OrganizationEdit,
          name: 'organizationEdit'
        },
        {
          path: '/qrcode',
          component: QRCode,
          name: 'qrcode'
        },
        {
          path: 'users',
          component: Users,
          name: 'users'
        },
        {
          path: 'users/:id',
          component: UserEdit,
          name: 'userEdit'
        },
        {
          path: 'userme',
          component: UserMe,
          name: 'userMe'
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/passwordreset/form',
      component: PasswordResetForm,
      name: 'passwordResetForm'
    },
    {
      path: '/passwordreset/request',
      component: PasswordResetRequest,
      name: 'passwordResetRequest'
    },
    {
      path: '/passwordreset/confirm',
      component: PasswordResetConfirm,
      name: 'passwordResetConfirm'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js